import React from 'react';
import {times} from 'lodash';

interface ListingTableSkeletonProps {
  title: string;
  rows?: number;
}

export default function ListingTableSkeleton({title, rows = 5}: ListingTableSkeletonProps) {
  return (
    <>
      <h2>{title}</h2>
      <div className="college-listings-table table-striped">
        {times(rows, (row) => (
          <div key={row} className="shared-shimmer-text full" />
        ))}
      </div>
    </>
  );
}
